import { render, staticRenderFns } from "./RecentActivityView.vue?vue&type=template&id=1e52748f&scoped=true&"
import script from "./RecentActivityView.vue?vue&type=script&lang=ts&"
export * from "./RecentActivityView.vue?vue&type=script&lang=ts&"
import style0 from "./RecentActivityView.vue?vue&type=style&index=0&id=1e52748f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52748f",
  null
  
)

export default component.exports